import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobile = () => {
    setMobileOpen(false);
    setMobileCategoriesOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors duration-200"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-layout-grid-line text-xl text-primary-500"></i>
            </div>
            <span className="font-heading text-lg md:text-xl font-semibold tracking-tight whitespace-nowrap">
              Vigorbuy Spreadsheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Home
            </Link>
            <a href="#categories" className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer">
              Categories
            </a>
            <a href="#features" className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer">
              Features
            </a>
            <a href="#how-it-works" className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer">
              How It Works
            </a>
            <a href="#faq" className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer">
              FAQ
            </a>
            <Link
              to="/vigorbuy-spreadsheet-shopping-guide"
              className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Shopping Guide
            </Link>
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Articles
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>Buy It Now</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>

          <button
            className="md:hidden p-2 text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </span>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 px-2 transition-all duration-200 max-h-[80vh] overflow-y-auto">
            <div className="flex flex-col gap-1">
              <Link to="/" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-home-4-line text-primary-500"></i></span>
                Home
              </Link>

              <Link to="/vigorbuy-spreadsheet-shopping-guide" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-shopping-bag-3-line text-primary-500"></i></span>
                Shopping Guide
              </Link>

              <a href="#categories" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-grid-line text-primary-500"></i></span>
                Categories
              </a>

              <a href="#features" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-star-line text-primary-500"></i></span>
                Features
              </a>

              <a href="#how-it-works" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-compass-3-line text-primary-500"></i></span>
                How It Works
              </a>

              <a href="#faq" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-question-line text-primary-500"></i></span>
                FAQ
              </a>

              <Link to="/vigorbuy-spreadsheet-guide" onClick={closeMobile} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-article-line text-primary-500"></i></span>
                Articles
              </Link>

              {/* Mobile Categories Accordion */}
              <div className="mt-3 pt-3 border-t border-background-200/70">
                <button
                  onClick={() => setMobileCategoriesOpen(!mobileCategoriesOpen)}
                  className="w-full flex items-center justify-between py-2.5 px-3 rounded-lg hover:bg-background-100 text-foreground-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-5 h-5 flex items-center justify-center"><i className="ri-stack-line text-accent-500"></i></span>
                    <span>Shop Categories (14)</span>
                  </div>
                  <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${mobileCategoriesOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </span>
                </button>

                {mobileCategoriesOpen && (
                  <div className="mt-1 ml-3 space-y-0.5">
                    {categories.map((cat) => (
                      <a
                        key={cat.id}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        onClick={closeMobile}
                        className="flex items-center gap-3 py-2 px-3 rounded-lg hover:bg-background-100 text-foreground-600 text-sm transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <span className="w-5 h-5 flex items-center justify-center"><i className={`${cat.icon} text-accent-500`}></i></span>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <div className="mt-3 pt-3 border-t border-background-200/70">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center justify-center gap-2.5 py-3 px-5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <span>Buy It Now</span>
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line text-sm"></i></span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}